export type CashTradeReasonClassType = Constant<typeof CashTradeReasonClass>

export const CashTradeReasonClass = {
    BUY_ACCUMULATE: 'BUY_ACCUMULATE',
    BUY_USE: 'BUY_USE',
    EVENT: 'EVENT',
    BUY_CANCEL_ACM: 'BUY_CANCEL_ACM',
    CS: 'CS',
    RETURN_PAY: 'RETURN_PAY',
    CHANGE_PAY: 'CHANGE_PAY',
    EXCHANGE_ACM_EXHAUST: 'EXCHANGE_ACM_EXHAUST',
    REPAYMENT_CANCEL: 'REPAYMENT_CANCEL',
    REPAYMENT: 'REPAYMENT',
    WRITE_REVIEW: 'WRITE_REVIEW',
    WRITE_PREMIUM_REVIEW: 'WRITE_PREMIUM_REVIEW',
    ADD_CUSTOM_WRITE_REVIEW: 'ADD_CUSTOM_WRITE_REVIEW',
    SA_ADD_ACCUMULATE: 'SA_ADD_ACCUMULATE',
    SA_PL_ADD_ACCUMULATE: 'SA_PL_ADD_ACCUMULATE',
    MERCHANT_ADD_ACCUMULATE: 'MERCHANT_ADD_ACCUMULATE',
    COST_TRANSFER_TO_ADMIN: 'COST_TRANSFER_TO_ADMIN',
    SB_ADD_ACCUMULATE: 'SB_ADD_ACCUMULATE',
    AFTER_USE_WRITE_REVIEW: 'AFTER_USE_WRITE_REVIEW',
    AFTER_USE_WRITE_PREMIUM_REVIEW: 'AFTER_USE_WRITE_PREMIUM_REVIEW',
    CHOICE_BEST_REVIEW: 'CHOICE_BEST_REVIEW',
    INPUT_MY_SIZE: 'INPUT_MY_SIZE',
    REVIEW_EVENT: 'REVIEW_EVENT',
    LOG_EYE_ADD_ACCUMULATE: 'LOG_EYE_ADD_ACCUMULATE',
    CHARGE_USE_ADD_ACM: 'CHARGE_USE_ADD_ACM',
    ORDER_CHARGE_USE_ADD_ACM: 'ORDER_CHARGE_USE_ADD_ACM',
    NAVER_BANKBOOK_ADD_ACM: 'NAVER_BANKBOOK_ADD_ACM',
    RENTAL_CONTRACT_ACM: 'RENTAL_CONTRACT_ACM',
    CREDIT_CARD_USE_ADD_ACM: 'CREDIT_CARD_USE_ADD_ACM',
    PREPAID_CARD_USE_ACM: 'PREPAID_CARD_USE_ACM',
    NAVER_MOVIE_REVIEW: 'NAVER_MOVIE_REVIEW',
    GIFT_ACM: 'GIFT_ACM',
    GIFT_USE: 'GIFT_USE',
    PARTNER_EVENT_ACM: 'PARTNER_EVENT_ACM',
    EXPIRED_USE: 'EXPIRED_USE',
    PAY_BENEFIT_CARD_ACM: 'PAY_BENEFIT_CARD_ACM',
    TRANSFER_COUPON_POINT_ACM: 'TRANSFER_COUPON_POINT_ACM',
    BANK_ACCOUNT_USE_ADD_ACM: 'BANK_ACCOUNT_USE_ADD_ACM',
    NPAY_COUPON_POINT_ACM: 'NPAY_COUPON_POINT_ACM',
    PAY_MONEY_TO_REWORD_POINT: 'PAY_MONEY_TO_REWORD_POINT',
    LEAVED_MEMBER_EXTINCTION: 'LEAVED_MEMBER_EXTINCTION',
    PRE_USE_ACM: 'PRE_USE_ACM',
    COLLECTION_PAYLATER_DEBT: 'COLLECTION_PAYLATER_DEBT',
    /** 멤버십 적립 */
    MEMBERSHIP_ACM: 'MEMBERSHIP_ACM',
    MERCHANT_SCHEDULED_ACM: 'MERCHANT_SCHEDULED_ACM',
    MEMBERSHIP_LOG_EYE_ADD_ACCUMULATE: 'MEMBERSHIP_LOG_EYE_ADD_ACCUMULATE',
    MERCHANT_BUY_ACCUMULATE: 'MERCHANT_BUY_ACCUMULATE',
    BUY_ADD_ACCUMULATE: 'BUY_ADD_ACCUMULATE',
    /** 이벤트 적립 */
    PROMOTION_ACM: 'PROMOTION_ACM',
    EXCHANGE_NSTAMP: 'EXCHANGE_NSTAMP',
    REG_USER: 'REG_USER',
    WORD_OF_MOUTH: 'WORD_OF_MOUTH',
    BUY_CANCEL_USE: 'BUY_CANCEL_USE',
    EXCHANGE_USED_ACM: 'EXCHANGE_USED_ACM',
    EXCHANGE_ACM_ACM: 'EXCHANGE_ACM_ACM',
    EXCHANGE_EXHAUST_EXHAUST: 'EXCHANGE_EXHAUST_EXHAUST',
    CANCEL_ROLLBACK: 'CANCEL_ROLLBACK',
    IMPLOYEE_ACM: 'IMPLOYEE_ACM',
    IMMEDIATELY_COUPON_CHANGE_ACCUMULATE: 'IMMEDIATELY_COUPON_CHANGE_ACCUMULATE',
    IMMEDIATELY_COUPON_CHANGE_ACCUMULATE_CANCEL: 'IMMEDIATELY_COUPON_CHANGE_ACCUMULATE_CANCEL',
    SA_ADD_ACCUMULATE_CANCEL: 'SA_ADD_ACCUMULATE_CANCEL',
    DA_ADD_ACCUMULATE: 'DA_ADD_ACCUMULATE',
    DA_ADD_ACCUMULATE_CANCEL: 'DA_ADD_ACCUMULATE_CANCEL',
    SA_PL_ADD_ACCUMULATE_CANCEL: 'SA_PL_ADD_ACCUMULATE_CANCEL',
    MERCHANT_ADD_ACCUMULATE_CANCEL: 'MERCHANT_ADD_ACCUMULATE_CANCEL',
    SB_ADD_ACCUMULATE_CANCEL: 'SB_ADD_ACCUMULATE_CANCEL',
    NCP_ADD_ACCUMULATE: 'NCP_ADD_ACCUMULATE',
    NCP_ADD_ACCUMULATE_CANCEL: 'NCP_ADD_ACCUMULATE_CANCEL',
    NCP_SELECTIVE_ADD_ACCUMULATE: 'NCP_SELECTIVE_ADD_ACCUMULATE',
    NCP_SELECTIVE_ADD_ACCUMULATE_CANCEL: 'NCP_SELECTIVE_ADD_ACCUMULATE_CANCEL',
    NCP_NECESSITY_ADD_ACCUMULATE: 'NCP_NECESSITY_ADD_ACCUMULATE',
    NCP_NECESSITY_ADD_ACCUMULATE_CANCEL: 'NCP_NECESSITY_ADD_ACCUMULATE_CANCEL',
    NCP_LIVE_ADD_ACCUMULATE: 'NCP_LIVE_ADD_ACCUMULATE',
    NCP_LIVE_ADD_ACCUMULATE_CANCEL: 'NCP_LIVE_ADD_ACCUMULATE_CANCEL',
    LOG_EYE_ADD_ACCUMULATE_CANCEL: 'LOG_EYE_ADD_ACCUMULATE_CANCEL',
    NAVER_BOOKING_REVIEW: 'NAVER_BOOKING_REVIEW',
    GIFT_ACM_CANCEL: 'GIFT_ACM_CANCEL',
    GIFT_USE_CANCEL: 'GIFT_USE_CANCEL',
    EVENT_USE: 'EVENT_USE',
    EVENT_ACM_CANCEL: 'EVENT_ACM_CANCEL',
    EVENT_USE_CANCEL: 'EVENT_USE_CANCEL',
    NAVER_ORDER_REVIEW: 'NAVER_ORDER_REVIEW',
} as const
